module.exports = __webpack_public_path__ + "img/workshops_mobile.5aeec0b3.svg";